export const SECTION_NAME = 'SSO Configurations';

export const SSO_URL_CONTROL = 'idp-login-url-control';
export const SSO_URL_REQUIRED_ERROR_CODE = 'sso-url-required';
export const SSO_URL_REQUIRED_ERROR_MESSAGE = 'Identity Provider (IdP) Login URL is required field.';

export const SSO_CERTIFICATE_CONTROL = 'trusted-signing-certificate-control';
export const SSO_CERTIFICATE_REQUIRED_ERROR_CODE = 'sso-certificate-required';
export const SSO_CERTIFICATE_REQUIRED_ERROR_MESSAGE = 'Trusted Signing Certificate is required field.';

export const DOMAINS_CONTROL = 'sso-domains-control';
export const DOMAINS_REQUIRED_ERROR_CODE = 'sso-domains-required';
export const DOMAINS_REQUIRED_ERROR_MESSAGE = 'Domains are required fields.';

export const DOMAIN_URL_FORBIDDEN_SYMBOL = '@';
export const DOMAIN_URL_FORBIDDEN_SYMBOL_MESSAGE = 'The "@" symbol is not allowed in Domain URL';
